module.exports = __webpack_public_path__ + "static/img/question6-1.c6b6b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question6-1.png
// module id = 8khG
// module chunks = 1